<template>
  <!-- 会员计算进度查询 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item>
          <a-button type="primary" @click="search()">查询</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      size="middle"
      row-key="ID"
      :columns="columns"
      :loading="loading"
      :data-source="datarow"
      :pagination="false"
        bordered
        :scroll="{ x: false, y: 600 }"
    >
      <template slot="Type" slot-scope="text, record">
        <span v-if="record.Type == 1">电子</span>
        <span v-else-if="record.Type == 2">真人</span>
        <span v-else-if="record.Type == 3">USDT</span>
        <span v-else-if="record.Type == 4">会员VIP</span>
      </template>
      <template slot="CalType" slot-scope="text, record">
        <span v-if="record.CalType == 2">期别计算(第{{record.TermIndex}}期) </span>
        <span v-else-if="record.CalType == 3"> 统计计算 </span>
        <span v-else-if="record.CalType == 4">继续计算(从第{{record.TermIndex}}期开始) </span>
        <span v-else>{{ record.CalType }}</span>
      </template>
      <template slot="State" slot-scope="text, record">
        <span v-if="record.State == 1 && (record.CalType == 3 ||  record.CalType == 4)">
          <a href="javascript:;" @click="showCalcProgress(record.ID)">计算中</a>
        </span>
        <span v-else-if="record.State == 1">计算中</span>
        <span v-else-if="record.State == 2">计算完成</span>
      </template>
      <template slot="Date" slot-scope="text, record">
        {{ transDate(record.Date) }}
      </template>
    </a-table>

    <!-------------------------------------------------------弹窗部份--------------------------------------------------------->
    <a-modal
      v-model="visible"
      title="计算进度"
      width="60%"
      ok-text="确定"
      cancel-text="取消"
      layout="inline"
    >
      <a-table
        size="middle"
        row-key="ID"
        :columns="Calcolumns"
        :data-source="calcdata"
        :pagination="false"
        bordered
        :scroll="{ x: false, y: 500 }"
      >
        <template slot="title">
          <a
            style="margin-left: 200"
            href="javascript:;"
            @click="showCalcProgress(base_id)"
          >
            <a-icon style="font-size: 30px" type="redo" />
          </a>
        </template>
        <template slot="State" slot-scope="text, record">
          <span v-if="record.State == 0">计算中</span>
          <span v-else-if="record.State == 1">计算完成</span>
        </template>
        <template slot="Date" slot-scope="text, record">
          {{ transDate(record.Date) }}
        </template>
      </a-table>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
  </a-layout-content>
</template>
<script>
export default {
  data() {
    return {
      columns: IninTable(),
      loading: false,
      datarow: [],
      visible: false,
      Calcolumns: CalcIninTable(),
      calcdata: [],
      base_id: 0,
    };
  },
  methods: {
    search() {
      let params = {
        ID: 0,
      };
      this.axios.post("/userbet/getcalprogress", params).then((res) => {
        this.datarow = res.data;
      });
    },
    transDate(value) {
      return this.getDate(value, "yyyy-MM-dd HH:mm:ss");
    },
    showCalcProgress(id) {
      this.base_id = id;
      this.visible = true;
      let params = {
        ID: id,
      };
      this.axios.post("/userbet/getcalprogress", params).then((res) => {
        this.calcdata = res.data;
      });
    },
  },
  //首次加载
  created() {
    this.search();
  },
};

const IninTable = function IninTable() {
  var header = [];
  header.push({
    title: "计算ID",
    align: "center",
    width: 100,
    dataIndex: "ID",
  });
  header.push({
    title: "会员升级类型",
    align: "center",
    dataIndex: "Type",
    scopedSlots: { customRender: "Type" },
  });
  header.push({
    title: "计算类型",
    align: "center",
    dataIndex: "CalType",
    scopedSlots: { customRender: "CalType" },
  });
  header.push({
    title: "状态",
    align: "center",
    dataIndex: "State",
    scopedSlots: { customRender: "State" },
  });
  header.push({
    title: "时间",
    align: "center",
    dataIndex: "Date",
    sorter: (a, b) =>
      new Date(a.Date.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.Date.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    scopedSlots: { customRender: "Date" },
  });
   header.push({
    title: "操作者",
    align: "center",
    dataIndex: "Editor",
    scopedSlots: { customRender: "Editor" },
  });

  return header;
};

const CalcIninTable = function CalcIninTable() {
  var header = [];
  header.push({ title: "计算ID", align: "center", dataIndex: "BaseID" });
  header.push({ title: "期别", align: "center", dataIndex: "TermID" });
  header.push({
    title: "状态",
    align: "center",
    dataIndex: "State",
    scopedSlots: { customRender: "State" },
  });
  header.push({
    title: "时间",
    align: "center",
    dataIndex: "Date",
    sorter: (a, b) =>
      new Date(a.Date.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.Date.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    scopedSlots: { customRender: "Date" },
  });
  header.push({ title: "计算次数", align: "center", dataIndex: "CalcCount" });

  return header;
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/userbetmanager/progress.vue